<div class="container-fluid banner">
  <img src="../../assets/contact.jpg" class="img-responsive" style="width: 100%;">
  <div class="top-left">
    <h1>Contact Us </h1>
  </div>
</div><br>
<div class="container">
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12 box">
      <div class="row">
        <h2>Hyderabad,India</h2>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="glyphicon glyphicon-map-marker circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>3rd floor Millenium Square Building, Above Ratnadeep <br>Supermarket, Lumbini Avenue, Gachibowli,
            Hyderabad,<br> Telangana, India 500032</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="	glyphicon glyphicon-envelope circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>{{brandData?.email}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="glyphicon glyphicon-earphone circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>+91 91540 45404 | +91 91000 58333</p>
        </div>
      </div>
      <div class="row">
        <h2>Sunol, USA</h2>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="glyphicon glyphicon-map-marker circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>463 Kilkare Rd<br>
            Sunol, CA 94586 
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="	glyphicon glyphicon-envelope circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>{{brandData?.email}}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="glyphicon glyphicon-earphone circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>925 719-4814</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-1 col-md-1 col-sm-1"><span class="glyphicon glyphicon-globe circle"></span></div>
        <div class="col-lg-11 col-md-11 col-sm-11">
          <p>{{brandData?.webSite}}</p>
        </div>
      </div>
      <div class="row">
        <h2>Connect with us</h2>
      </div>
      <div class="row social">
        <!-- <a href={{socialUrl?.twitter}} target="_blank" ><img src="assets/c-twitter.png"></a>&nbsp;&nbsp; -->
        <a href={{socialUrl?.facebook}} target="_blank"><img src="assets/c-facebook.png"></a>&nbsp;&nbsp;
        <!-- <a href={{socialUrl?.insta}} target="_blank"> <img src="assets/c-insta.png"></a> -->

      </div>

    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 box1">
      <div class="row">
        <h6>FEEL FREE TO CONTACT US</h6>
        <h5>LEAVE A MESSAGE</h5>
      </div>
      <div class="row">
        <form [formGroup]="reqForm">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <input type="text" placeholder="Name" name="name" formControlName='customerName' value="{{reqForm.get('customerName').value|titlecase}}" class="form-control">
            <div *ngIf="reqForm.get('customerName').hasError('required') && reqForm.get('customerName').touched">
              <small class="error">Name should not be empty</small>
            </div>
            <div *ngIf="reqForm.get('customerName').hasError('minlength')&& reqForm.get('customerName').touched">
              <small class="error">Name should contain minimum 3 characters</small>
            </div>
            <div *ngIf="reqForm.get('customerName').hasError('maxlength')&& reqForm.get('customerName').touched">
              <small class="error">Name should contain maximum 35 characters</small>
            </div>
            <div *ngIf="reqForm.get('customerName').hasError('pattern')&& reqForm.get('customerName').touched">
              <small class="error">Please enter only alphabets</small>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <input type="email" placeholder="Email" name="email" formControlName='email' class="form-control">
            <div *ngIf="reqForm.get('email').hasError('required')&& reqForm.get('email').touched">
              <small class="error">Please enter the email</small>
            </div>
            <div *ngIf="reqForm.get('email').hasError('pattern')&& reqForm.get('email').touched">
              <small class="error">Please enter valid email</small>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <input type="phone" placeholder="Phone" name="phone" class="form-control" formControlName='phoneNumber'>
            <div *ngIf="reqForm.get('phoneNumber').hasError('required')&& reqForm.get('phoneNumber').touched">
              <small class="error">Please enter phone number</small>
            </div>
            <div *ngIf="reqForm.get('phoneNumber').hasError('pattern')&& reqForm.get('phoneNumber').touched;else test">
              <small class="error">Please enter in digits</small>
            </div>
            <ng-template #test>
              <div *ngIf="reqForm.get('phoneNumber').hasError('minlength')&& reqForm.get('phoneNumber').touched">
                <small class="error">Please enter minimum 10 digits</small>
              </div>
              <div *ngIf="reqForm.get('phoneNumber').hasError('maxlength')&& reqForm.get('phoneNumber').touched">
                <small class="error">Please enter maximum 10 digits</small>
              </div>
            </ng-template>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <textarea name="message" containers="7" placeholder="Message" formControlName='message'></textarea>
            <div
            *ngIf="reqForm.get('message').hasError('required')&& reqForm.get('message').touched">
            <small class="error">Please enter message</small>
          </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 submit">
            <button type="button" (click)="reqContact()">submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div><br>

<ng-template #msg>
  <!-- <div class="modal-container"> -->
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Message</h4>
    <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i class="bi bi-x-circle"></i></button>
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    <p class="text-center">{{modalService.config.initialState.message}}</p>
  </div>
  <!-- Modal footer -->
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
    <button type="button" class="btn-blue" (click)="modalClose()">OK</button>
  </div>
  <!-- </div> -->
</ng-template>